import Vue from "vue";
// import GetRate from "@/components/requests/internal/GetRate.vue";
// import ImagePerson from "@/components/functionals/ImagePerson.vue";
// import RequestType from "@/components/requests/internal/RequestType.vue";
// import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
// import ColorInternarStatus from "@/components/functionals/ColorInternarStatus";
// import ColorInternarRequest from "@/components/functionals/ColorInternarRequest";
import { getActions, COLUMNS } from "@/components/internal_requests/help_ir";

const vue = new Vue();
export var dialog = {
  type: "",
  title: "",
  visible: false,
  responsableId: null,
  comment: "",
  internalRequestId: 0
};
export var showDetailRate = false;
export var detailDataRate = {
  requestsId: 0,
  comments: [],
  descripcionLaga: "",
  descripcionCorta: ""
};

export const getPendingRequests = async function (currentUser) {
  //console.log("getPendingRequests");
  let tableData = [];
  await vue.$http
    .get(
      "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisor",
      {
        timeout: 3 * 60 * 1000,
        params: {
          PersonId: 0, //currentUser.EmployeeId,
          DirectionId: 0, //currentUser.DireccionID,
          Company: currentUser.CompanySelected,
          Status: 2,
          CreateByMe: true,
          All: false,
          isSupervisor: currentUser.isSupervisor,
          page: 1,
          limit: 1000,
          skit: 0
        }
        //Se hardcodearon ciertos parámetros debido a que no son necesarios para la consulta que me intereza.
      }
    )
    .then((resp) => {
      tableData = resp.data.Items;
      //console.log("getPendingRequests tableData",tableData);
    })
    .catch((err) => {
      tableData = [];
      throw err;
    });

  return tableData;
};

export const RequestColumns = COLUMNS;
// [
//   {
//     prop: "Id",
//     label: "No",
//     minWidth: 80,
//     fixed: true,
//     sortable: true,
//     formatter: ColorInternarRequest
//   },
//   {
//     prop: "CreatedAt",
//     label: "Fecha",
//     minWidth: 120,
//     formatter: CellDateTime
//   },
//   {
//     prop: "TipoSolicitud",
//     label: "Tipo de Solicitud",
//     minWidth: 250,
//     formatter: RequestType
//   },
//   {
//     prop: "SlaDaysToResponse",
//     label: "Sla (dias)",
//     minWidth: 100
//   },
//   {
//     prop: "DiasRetrasadosSla",
//     label: "Atraso",
//     minWidth: 120
//   },
//   {
//     prop: "StatusSlaDescripcion",
//     label: "Cumplimiento",
//     minWidth: 130,
//     formatter: ColorInternarStatus
//   },
//   {
//     prop: "corta",
//     label: "Descripcion",
//     minWidth: 250
//   },
//   {
//     prop: "Valoracion",
//     label: "Calificacion",
//     minWidth: 200,
//     formatter: GetRate
//   },
//   {
//     prop: "ComentarioValoracion",
//     label: "Comentario Calificacion",
//     minWidth: 250
//   },
//   {
//     prop: "Responsable",
//     label: "Responsable",
//     minWidth: 250,
//     formatter: ImagePerson,
//     attrs: {
//       imgKey: "ResponsableImage"
//     }
//   },
//   {
//     prop: "CreateBy",
//     label: "Creado Por",
//     minWidth: 250,
//     formatter: ImagePerson,
//     attrs: {
//       imgKey: "CreatorImage"
//     }
//   },
//   {
//     prop: "Supervisor",
//     label: "Supervisor",
//     minWidth: 250,
//     formatter: ImagePerson,
//     attrs: {
//       imgKey: "SupervisorImage"
//     }
//   }
// ];

export const RequestActions = (p) =>
  getActions(p).closed.filter(
    (action) =>
      action.command === "set" ||
      action.command === "addComment" ||
      action.command === "reopen" ||
      action.command ===
        "details" /*action.command.includes("set" || "details" || "cancell")*/
  );

export const RequestActionHandler = (option) => handlePushAction(option);

const handlePushAction = function (option) {
  // console.log("handlePushAction: ", option.row);
  switch (option.command) {
    case "details": {
      dialog.internalRequestId = option.row.Id;
      detailDataRate = {
        requestsId: option.row.Id,
        comments: [],
        descripcionLaga: option.row.Descripcion,
        descripcionCorta: option.row.corta,
        commentReasonToReopen: option.row.ReasonToReopen,
        Reopen: option.row.Reopen
      };
      if (option.row != null && option.row.Activities != null) {
        const c = option.row.Activities.filter((a) => (a.Type = 1));
        detailDataRate.comments = JSON.parse(JSON.stringify(c));
      }
      showDetailRate = true;
      break;
    }
    default:
      break;
  }
};

//export const RequestActions = [];

//export const RequestActionHandler = async function() {};
